var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shippingList" }, [
    _c(
      "div",
      { staticClass: "top-filter-form" },
      [
        _c(
          "el-form",
          {
            ref: "filterForm",
            attrs: {
              model: _vm.filterForm,
              inline: true,
              "label-position": "left"
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "订单类型" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择订单类型", clearable: "" },
                    model: {
                      value: _vm.filterForm.orderType,
                      callback: function($$v) {
                        _vm.$set(_vm.filterForm, "orderType", $$v)
                      },
                      expression: "filterForm.orderType"
                    }
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "普通订单", value: "0" }
                    }),
                    _vm._v(" "),
                    _vm.isJgj !== "1"
                      ? _c("el-option", {
                          attrs: { label: "谷仓订单", value: "2" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "主单号" } },
              [
                _c("el-input", {
                  staticClass: "main-order-number-input",
                  attrs: {
                    placeholder: "多个主单号用英文半角’,‘隔开",
                    clearable: ""
                  },
                  model: {
                    value: _vm.filterForm.mainOrderNumber,
                    callback: function($$v) {
                      _vm.$set(_vm.filterForm, "mainOrderNumber", $$v)
                    },
                    expression: "filterForm.mainOrderNumber"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "出库时间" } },
              [
                _c("el-date-picker", {
                  attrs: {
                    size: "mini",
                    type: "datetimerange",
                    "picker-options": _vm.pickerOptions,
                    "range-separator": "至",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间",
                    align: "right",
                    "value-format": "yyyy-MM-dd HH:mm:ss"
                  },
                  model: {
                    value: _vm.filterForm.outStockDate,
                    callback: function($$v) {
                      _vm.$set(_vm.filterForm, "outStockDate", $$v)
                    },
                    expression: "filterForm.outStockDate"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.onSubmitFilter }
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "filter-reset-btn",
                    attrs: { size: "small" },
                    on: { click: _vm.handleReset }
                  },
                  [_vm._v("重置")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "main print-font" }, [
      _c("div", { staticClass: "title print-font" }, [_vm._v("三方发货清单")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "print-font" },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.shippingForm,
                "label-position": "left"
              }
            },
            [
              _c("el-form-item", { attrs: { label: "名称:" } }, [
                _vm._v(_vm._s(_vm.shippingForm.shop_name))
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "日期:" } }, [
                _vm._v(_vm._s(_vm.shippingForm.date))
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-form-item", { attrs: { label: "收货方:" } }, [
                    _vm._v(_vm._s(_vm.shippingForm.user_name))
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "收货地址:" } }, [
                    _vm._v(_vm._s(_vm.shippingForm.address))
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "联系方式:" } }, [
                    _vm._v(_vm._s(_vm.shippingForm.mobile))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.shippingTableData,
                border: "",
                "span-method": _vm.objectSpanMethod,
                "show-summary": "",
                "summary-method": _vm.getSummaries
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created_at", label: "推送时间" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "main_number", label: "主订单号" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "编号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.serial_number
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.serial_number
                                    .split("-")
                                    .slice(3)
                                    .join("-")
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.express && _vm.isZhifaOrFactory
                          ? _c("span", [
                              _vm._v("(" + _vm._s(scope.row.express) + ")")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mo_statusName", label: "状态" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "weight", label: "打包称重(kg)" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "box_num", label: "打包箱数" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "box_code", label: "箱码", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.box_code
                          ? _c(
                              "span",
                              _vm._l(scope.row.box_code.split(","), function(
                                item
                              ) {
                                return _c(
                                  "span",
                                  {
                                    key: item,
                                    staticStyle: { display: "block" }
                                  },
                                  [_vm._v(_vm._s(item))]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { label: "是否签收" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "warning-info" }, [
            _vm._v(
              "\n        注意：签收前请查验货物，您的签名意味着货物签收确认。签收人签名：\n      "
            )
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "btn" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: { click: _vm.myPrint }
          },
          [_vm._v("打印")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18f098de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18f098de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/shippingList.vue
// module id = null
// module chunks = 